import { render, staticRenderFns } from "./YandexCaptchaField.vue?vue&type=template&id=4483ce09&lang=pug"
import script from "./YandexCaptchaField.vue?vue&type=script&lang=js"
export * from "./YandexCaptchaField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports